export default __webpack_public_path__ + "static/media/sharpshooters_oath.1d149cf5.png";